import { useAppSelector } from "../../../hooks/redux";

/** Whether the beta-gated Med Rec tab is available to this user. Drives both
 *  the citation route for ``discharge_medrec:`` (→ Med Rec tab) and whether
 *  those chips render at all — they're hidden when the tab isn't reachable
 *  (see ``processHtmlSources``). */
export const useMedRecVisible = (): boolean => {
  const betaFeaturesAllowedList = useAppSelector(
    (state) => state.auth.betaFeaturesAllowedList
  );
  return !!betaFeaturesAllowedList?.includes("medrec");
};
